// Mock data for FinVestra Consulting website

export const companyInfo = {
  name: "FinVestra Consulting FZ-LLC",
  tagline: "Strategic Excellence. Execution Mastery.",
  phone: "+971545278637",
  email: "admin@finvestrauae.com",
  whatsapp: "+971545278637",
  address: "Compass Building, Al Shohada Road, Al Hamra Industrial Zone – Free Zone, Ras Al Khaimah, United Arab Emirates",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3608.6!2d55.9!3d25.7!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjXCsDQyJzAwLjAiTiA1NcKwNTQnMDAuMCJF!5e0!3m2!1sen!2sae!4v1234567890"
};

export const heroImages = {
  home: "https://images.unsplash.com/photo-1758518727613-00192aed759b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBidXNpbmVzcyUyMGNvbnN1bHRhdGlvbnxlbnwwfHx8fDE3NzA2MjU2NDB8MA&ixlib=rb-4.1.0&q=85",
  about: "https://images.unsplash.com/photo-1758518725921-1eb74ed293be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxjb3Jwb3JhdGUlMjBidXNpbmVzcyUyMGNvbnN1bHRhdGlvbnxlbnwwfHx8fDE3NzA2MjU2NDB8MA&ixlib=rb-4.1.0&q=85",
  services: "https://images.unsplash.com/photo-1752170080635-db168448f85d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBvZmZpY2UlMjB0ZWFtfGVufDB8fHx8MTc3MDYyNTY0NHww&ixlib=rb-4.1.0&q=85",
  contact: "https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjBidXNpbmVzcyUyMGNvbnN1bHRhdGlvbnxlbnwwfHx8fDE3NzA2MjU2NDB8MA&ixlib=rb-4.1.0&q=85"
};

export const services = [
  {
    id: "investment",
    title: "Investment Consultancy",
    icon: "TrendingUp",
    description: "Strategic investment advisory and portfolio management aligned with your business objectives and risk appetite.",
    benefits: ["Portfolio optimization", "Risk assessment", "Market analysis", "ROI maximization"],
    category: "finance"
  },
  {
    id: "project-management",
    title: "Project Management Consultancy",
    icon: "Briefcase",
    description: "End-to-end project execution from planning to delivery, ensuring on-time and on-budget completion.",
    benefits: ["Project planning & execution", "Stakeholder management", "Resource optimization", "Delivery assurance"],
    category: "management"
  },
  {
    id: "cost-control",
    title: "Cost Control & Risk Management",
    icon: "Shield",
    description: "Proactive cost monitoring and risk mitigation strategies to protect your business investments.",
    benefits: ["Budget monitoring", "Risk identification", "Mitigation strategies", "Financial controls"],
    category: "finance"
  },
  {
    id: "business-advisory",
    title: "Management & Business Advisory",
    icon: "Target",
    description: "Strategic business consulting to drive growth, efficiency, and sustainable competitive advantage.",
    benefits: ["Strategic planning", "Operational efficiency", "Growth strategies", "Performance optimization"],
    category: "strategy"
  },
  {
    id: "commercial-intelligence",
    title: "Commercial Intelligence",
    icon: "BarChart3",
    description: "Data-driven market insights and competitive intelligence to inform strategic decision-making.",
    benefits: ["Market research", "Competitive analysis", "Industry insights", "Data analytics"],
    category: "strategy"
  },
  {
    id: "auditing",
    title: "Auditing & Assurance Support",
    icon: "FileCheck",
    description: "Comprehensive audit preparation and assurance services ensuring regulatory compliance and transparency.",
    benefits: ["Audit preparation", "Compliance review", "Financial assurance", "Regulatory adherence"],
    category: "finance"
  },
  {
    id: "icv-advisory",
    title: "ICV Advisory",
    icon: "Award",
    description: "Expert guidance on ADNOC In-Country Value certification to maximize local content scoring.",
    benefits: ["ICV certification support", "Score optimization", "Compliance guidance", "Documentation assistance"],
    category: "compliance"
  },
  {
    id: "recruitment",
    title: "Recruitment & Talent Advisory",
    icon: "Users",
    description: "Specialized recruitment services for white-collar and blue-collar positions across industries.",
    benefits: ["Executive search", "Mass recruitment", "Talent assessment", "Onboarding support"],
    category: "hr"
  },
  {
    id: "business-setup",
    title: "Business Setup & Company Registration",
    icon: "Building2",
    description: "Complete company formation services in UAE free zones and mainland with regulatory compliance.",
    benefits: ["Company formation", "License processing", "PRO services", "Regulatory compliance"],
    category: "setup"
  },
  {
    id: "public-relations",
    title: "Public Relations & Corporate Support",
    icon: "Megaphone",
    description: "Strategic PR and corporate communications to enhance brand reputation and stakeholder engagement.",
    benefits: ["Brand positioning", "Media relations", "Corporate communications", "Reputation management"],
    category: "marketing"
  }
];

export const industries = [
  { name: "Oil & Gas", icon: "Fuel" },
  { name: "Construction", icon: "HardHat" },
  { name: "Manufacturing", icon: "Factory" },
  { name: "Hospitality", icon: "Hotel" },
  { name: "Technology", icon: "Laptop" },
  { name: "Healthcare", icon: "HeartPulse" },
  { name: "Real Estate", icon: "Home" },
  { name: "Retail", icon: "ShoppingBag" }
];

export const values = [
  {
    title: "Excellence",
    description: "We deliver exceptional quality in every engagement, exceeding client expectations through meticulous attention to detail.",
    icon: "Star"
  },
  {
    title: "Integrity",
    description: "We uphold the highest ethical standards, ensuring transparency and trust in all our professional relationships.",
    icon: "Shield"
  },
  {
    title: "Execution",
    description: "We don't just advise—we execute. Our hands-on approach ensures strategies translate into tangible results.",
    icon: "Zap"
  },
  {
    title: "Partnership",
    description: "We view our clients as long-term partners, invested in their sustained growth and success.",
    icon: "Handshake"
  }
];

export const recruitmentServices = {
  whiteCollar: {
    title: "White-Collar Recruitment",
    description: "Executive search and professional hiring for leadership and specialist roles across industries.",
    roles: [
      "C-Suite Executives",
      "Finance & Accounting Professionals",
      "Engineers & Technical Specialists",
      "Project Managers",
      "Business Development Managers",
      "IT & Technology Experts"
    ]
  },
  blueCollar: {
    title: "Blue-Collar Recruitment",
    description: "Mass recruitment and workforce mobilization for operational and technical positions.",
    roles: [
      "Construction Workers",
      "Technicians & Operators",
      "Drivers & Logistics Staff",
      "Maintenance Crew",
      "Manufacturing Workers",
      "Service Personnel"
    ]
  }
};

export const icvDetails = {
  overview: "In-Country Value (ICV) certification is mandatory for companies supplying to ADNOC and government entities in the UAE. Our ICV Advisory ensures you maximize your local content score and remain competitive.",
  services: [
    "ICV Certificate Application & Renewal",
    "ICV Score Optimization Strategies",
    "Goods & Services Reclassification",
    "Supplier Development Programs",
    "Compliance Documentation Support",
    "Training & Capacity Building"
  ],
  benefits: [
    "Increased competitiveness in government tenders",
    "Enhanced eligibility for ADNOC contracts",
    "Improved local content contribution",
    "Regulatory compliance assurance"
  ]
};
